







































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { JobUserAssignment } from '@/models/jobStatus/jobUserAssignment';
import { JobUserStatusEnum } from '@/types/jobUserStatus';
import { getStatusName, getStatusColor } from '@/services/jobService';
import moment from 'moment';
import * as JobsAPI from '@/api/jobsApi';
import JobStatusHistoryItem from '@/components/jobStatus/JobStatusHistoryItem.vue';
import JobStatusItemForm from '@/components/jobStatus/JobStatusItemForm.vue';

interface StatusChange {
  id: number;
  at: string;
  statusId: number;
  comment: string;
}

@Component({
  components: {
    JobStatusHistoryItem,
    JobStatusItemForm
  }
})
export default class JobStatusDetail extends Vue {
  @Prop({ type: Object, default: null }) public jobUserAssignment!: JobUserAssignment;

  private showStatusForm: boolean = false;
  private selectedStatusChange: StatusChange = null;
  private loading: boolean = false;
  private errorMessage: string = "";

  goBack(){
    this.$router.go(-1);
  }

  get jobUserAssignmentID(){
    return this.jobUserAssignment.id;
  }

  get jobUserAssignmentStatuses(){
    return this.jobUserAssignment.statuses;
  }

  get statusChanges(){
    return this.jobUserAssignmentStatuses.filter(x => x.status).map(x => {
      return {
        id: x.id,
        statusId: x.status.id,
        at: x.statusAt,
        offset: x.statusOffset,
        comment: x.comment,
        color: getStatusColor(x.status.id),
        isModified: false
      };
    }).sort((a, b) => {
      if(moment(a.at) < moment(b.at)){
        return 1;
      }

      if(moment(a.at) > moment(b.at)){
        return -1;
      }

      return 0;
    });
  }

  get statusChangesAndDates(){
    let items: any[] = [];

    let lastDate = moment();
    this.statusChanges.forEach(x => {
      if(moment(x.at).format("YYYY-MM-DD") != lastDate.format("YYYY-MM-DD")){
        items.push({
          isDateChange: true,
          dateString: moment(x.at).format("dddd, DD MMMM YYYY")
        });
        lastDate = moment(x.at);
      }

      items.push(x);
    });

    return items;
  }

  get statusOptions(){
    return [
      JobUserStatusEnum.TRAVEL, 
      JobUserStatusEnum.START_CONTINUE_WORK, 
      JobUserStatusEnum.NONE_CHARGEABLE,
      JobUserStatusEnum.BREAK, 
      JobUserStatusEnum.DAY_COMPLETE, 
      JobUserStatusEnum.FINISH_WORK
    ].map(x => {
      return {
        text: getStatusName(x),
        value: x
      };
    });
  }

  openCreateForm(){
    this.selectedStatusChange = null;
    this.showStatusForm = true;
  }

  openUpdateForm(statusChange: StatusChange){
    this.selectedStatusChange = statusChange;
    this.showStatusForm = true;
  }

  async remove(){
    if(this.selectedStatusChange == null){
      return;
    }

    await this.removeStatusHistory(this.selectedStatusChange.id);

  }

  async createOrUpdate(at: string, statusId: number, comment: string){
    if(this.selectedStatusChange != null) {
      await this.updateStatusHistory(this.selectedStatusChange.id, at, statusId, comment);
    } else {
      await this.createStatusHistory(at, statusId, comment);
    }
  }

  async removeStatusHistory(jobUserId: number){
    this.loading = true;

    try {
      await JobsAPI.removeStatusHistory(jobUserId);
      
      this.$emit('onDataChanged', {
        showServiceForm: false,
        shouldSendEmail: false
      });
      this.showStatusForm = false;

    } catch(err){
      this.errorMessage = err;
    }

    this.loading = false;
  }

  async createStatusHistory(at: string, statusId: number, comment: string){
    this.loading = true;

    try {
      var shouldSendEmail = await JobsAPI.createOrUpdateStatusHistory(this.jobUserAssignmentID, null, at, statusId, comment);
      console.log(shouldSendEmail);
      this.$emit('onDataChanged', {
        showServiceForm: statusId === JobUserStatusEnum.FINISH_WORK || statusId === JobUserStatusEnum.START_CONTINUE_WORK,
        shouldSendEmail: shouldSendEmail
      });

      this.showStatusForm = false;
    } catch(err){
      this.errorMessage = err;
    }

    this.loading = false;
  }

  async updateStatusHistory(jobUserAssignmentStatusID: number, at: string, statusId: number, comment: string){
    this.loading = true;

    try {
      var shouldSendEmail = await JobsAPI.createOrUpdateStatusHistory(this.jobUserAssignmentID, jobUserAssignmentStatusID, at, statusId, comment);

      this.$emit('onDataChanged', {
        showServiceForm: statusId === JobUserStatusEnum.FINISH_WORK,
        shouldSendEmail: shouldSendEmail
      });
      
      this.showStatusForm = false;
    } catch(err){
      this.errorMessage = err;
    }

    this.loading = false;
  }
}

